import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useRef, useCallback, } from "react";
import { cn } from "./utils";
const DialogContext = createContext({
    open: false,
    setOpen: () => { },
});
export function Dialog({ children, defaultOpen = false, open: controlledOpen, onOpenChange, }) {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
    const isControlled = controlledOpen !== undefined;
    const open = isControlled ? controlledOpen : uncontrolledOpen;
    const setOpen = isControlled
        ? (onOpenChange ?? (() => { }))
        : setUncontrolledOpen;
    return (_jsx(DialogContext.Provider, { value: { open, setOpen }, children: children }));
}
export function DialogTrigger({ children, ...props }) {
    const { setOpen } = useContext(DialogContext);
    return (_jsx("button", { type: "button", onClick: () => setOpen(true), ...props, children: children }));
}
export function DialogContent({ children, className, ...props }) {
    const { open, setOpen } = useContext(DialogContext);
    const ref = useRef(null);
    const handleKeyDown = useCallback((e) => {
        if (e.key === "Escape")
            setOpen(false);
    }, [setOpen]);
    useEffect(() => {
        if (open) {
            document.addEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "hidden";
            ref.current?.focus();
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "";
        };
    }, [open, handleKeyDown]);
    if (!open)
        return null;
    return (_jsxs("div", { className: "fixed inset-0 z-50 flex items-center justify-center", children: [_jsx("div", { className: "fixed inset-0 bg-black/50", onClick: () => setOpen(false), "aria-hidden": "true" }), _jsx("div", { ref: ref, role: "dialog", "aria-modal": "true", tabIndex: -1, className: cn("relative z-50 w-full max-w-lg rounded-lg bg-background p-6 shadow-lg", "animate-in fade-in-0 zoom-in-95", className), ...props, children: children })] }));
}
export function DialogTitle({ className, ...props }) {
    return _jsx("h2", { className: cn("text-lg font-semibold", className), ...props });
}
export function DialogDescription({ className, ...props }) {
    return (_jsx("p", { className: cn("text-sm text-muted-foreground", className), ...props }));
}
export function DialogClose({ children, ...props }) {
    const { setOpen } = useContext(DialogContext);
    return (_jsx("button", { type: "button", onClick: () => setOpen(false), ...props, children: children }));
}
//# sourceMappingURL=dialog.js.map